module.exports = __webpack_public_path__ + "img/service2-3.d07db5d9.jpg";